<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of app offers</h2>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add Offer
      </button>
    </div>
    <!-- Filter Bar -->
    <div class="flex flex-wrap items-end justify-between gap-2 mb-4">
      <div class="flex bg-gray-200 rounded-lg">
        <div class="flex bg-gray-200 rounded-lg">
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.active === '' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.active = '';
              fetchAll();
            "
          >
            All
          </button>
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.active === 'true' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-true0' : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.active = 'true';
              fetchAll();
            "
          >
            Active
          </button>
          <button
            :class="[
              'px-4 py-2 font-medium focus:outline-none transition select-none',
              search.active === 'false' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
            ]"
            @click="
              search.active = 'false';
              fetchAll();
            "
          >
            Inactive
          </button>
        </div>
      </div>
      <!--  Search and Sort Controls -->
      <div class="flex items-end gap-2">
        <!-- Offer Status Dropdown -->
        <vs-select :color="'#6366f1'" v-model="search.status" @change="fetchAll" class="w-36">
          <vs-select-item value="" text="Status" disabled />
          <vs-select-item value="all" text="All" />
          <vs-select-item value="past" text="Past" />
          <vs-select-item value="current" text="Current" />
          <vs-select-item value="upcoming" text="Upcoming" />
        </vs-select>
        <!-- Bundle ID Dropdown (already present) -->
        <vs-select :color="'#6366f1'" label="Bundle ID" v-model="search.bundleId" @change="fetchAll" class="w-48">
          <vs-select-item value="" text="All Apps" />
          <vs-select-item :key="index" :value="item.bundleId" :text="item.bundleId" v-for="(item, index) in apps" />
        </vs-select>
        <button
          @click="resetData()"
          class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
        >
          <span class="material-icons text-base">refresh</span> Reset
        </button>
      </div>
    </div>
    <!-- table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Title</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Bundle ID</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Start Date</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">End Date</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Discount</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Status</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cat, idx) in all" :key="cat._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-1">{{ idx + 1 }}</td>
            <td class="py-1">
              <img
                :src="cat.file[0].url || require('@/assets/images/No-image.png')"
                class="rounded-md object-cover"
                style="width: 90px; height: 60px"
              />
            </td>
            <td class="px-4 py-1 font-medium text-gray-800">{{ cat.title }}</td>
            <td class="px-4 py-1 text-center">{{ cat.bundleId }}</td>
            <td class="px-4 py-1 text-center">
              <span class="text-gray-500 text-sm">{{ formatDate(cat.startDate) }}</span>
            </td>
            <td class="px-4 py-1 text-center">
              <span class="text-gray-500 text-sm">{{ formatDate(cat.endDate) }}</span>
            </td>
            <td class="px-4 py-1">
              <div class="flex flex-col items-center justify-center">
                <span class="text-gray-500 text-sm flex gap-1">
                  Percentage:
                  <span>{{ cat.percentage }}%</span>
                </span>
                <span class="text-gray-500 text-sm flex gap-1">
                  Price:
                  <span>{{ cat.price }}</span>
                </span>
              </div>
            </td>
            <td class="px-4 py-1 text-center">
              <span
                :class="cat.active ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'"
                class="inline-block px-3 py-1 rounded-full font-semibold"
              >
                {{ cat.active ? "Active" : "Inactive" }}
              </span>
            </td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingItem(cat, 'clone')"> <vs-icon icon="content_copy" class="align-right" /> Clone </vs-dropdown-item>
                  <vs-dropdown-item @click="editingItem(cat)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      itemToDelete = cat;
                      deleteOfferPopup = true;
                    "
                  >
                    <vs-icon icon="delete_sweep" /> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- popup to add/edit -->
      <vs-popup :title="isNew ? 'Add New Offer' : clone ? 'Clone Offer' : 'Edit Offer'" :active.sync="defaultalert">
        <form @submit.prevent="btnAddBanner()">
          <div class="px-2 flex flex-col gap-1">
            <!-- select bundle id & status in flex row -->
            <div class="flex justify-between gap-4">
              <div class="w-1/2">
                <label class="block text-sm font-semibold">Select Bundle Id</label>
                <vs-select :color="colorx" v-model="banner.bundleId" icon="arrow_downward" class="w-full">
                  <vs-select-item value text="Choose Bundle Id" disabled />
                  <vs-select-item :value="item.bundleId" :text="item.bundleId" v-for="(item, index) in apps" :key="index" />
                </vs-select>
              </div>
              <div class="">
                <label class="block text-sm font-semibold">Status</label>
                <vs-checkbox v-model="banner.active">Active</vs-checkbox>
              </div>
            </div>

            <!-- title -->
            <label class="block text-sm font-semibold mt-1">Title*</label>
            <vs-input v-model="banner.title" placeholder="Keep short and simple" class="w-full" required :disabled="showLoader" />
            <!-- descrption -->
            <label class="block text-sm font-semibold">Description*</label>
            <vs-textarea v-model="banner.description" placeholder="Enter offer description" class="w-full h-32" required :disabled="showLoader" />
            <!-- start and end date -->
            <div class="flex justify-between gap-4">
              <div class="w-full">
                <label class="block text-sm font-semibold">Start Date*</label>
                <datepicker
                  placeholder="Start Date"
                  v-model="banner.startDate"
                  id="start_date"
                  format="yyyy-MM-dd"
                  input-class="border"
                  :disabledDates="disabledDates"
                  :open-date="new Date()"
                  @selected="dateSelected($event)"
                  :append-to-body="true"
                ></datepicker>
              </div>
              <div class="w-full">
                <label class="block text-sm font-semibold">End Date*</label>
                <datepicker
                  placeholder="End Date"
                  v-model="banner.endDate"
                  format="yyyy-MM-dd"
                  input-class="border"
                  :disabledDates="disabledDatesEnd"
                  :open-date="new Date()"
                  :append-to-body="true"
                ></datepicker>
              </div>
            </div>
            <!-- discount price and percentage -->
            <div class="flex justify-between gap-4">
              <div class="w-full">
                <label class="block text-sm font-semibold">Discount Price*</label>
                <vs-input type="number" v-model="banner.price" :min="1" class="w-full" />
              </div>
              <div class="w-full">
                <label class="block text-sm font-semibold">Discount Percentage (%) *</label>
                <vs-input type="number" v-model="banner.percentage" :min="1" class="w-full" />
              </div>
            </div>
            <!-- upload image -->
            <div class="flex flex-col md:flex-row md:items-center md:gap-6">
              <div class="flex-1" style="width: 100px; height: 150px">
                <div class="flex justify-between items-start">
                  <label class="block text-sm font-semibold">Image</label>
                  <button
                    v-if="displayImage1"
                    type="button"
                    color="danger"
                    class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
                    @click="clearImage"
                    :disabled="showLoader"
                  >
                    Clear
                  </button>
                </div>
                <div
                  class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                  style="width: 100%; height: 140px; min-height: 140px"
                  @dragover.prevent
                  @dragenter.prevent
                  @drop.prevent="onDropImage"
                  @click="triggerFileInput"
                >
                  <img v-if="displayImage1" :src="displayImage1" class="rounded-md object-cover border" style="width: 200px; max-height: 140px" />
                  <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
                    <span class="material-icons" style="font-size: 32px">cloud_upload</span>
                    <span>Drag & Drop or Click to Upload</span>
                  </div>
                  <input
                    type="file"
                    ref="fileInput"
                    class="hidden"
                    @change="onImageChange"
                    accept="image/jpeg,image/jpg,image/webp"
                    :disabled="showLoader"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row gap-2 mt-10">
            <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" @click="btnAddBanner" :disabled="showLoader">
              {{ isNew ? "Save" : clone ? "Clone and Save" : "Update" }}
            </vs-button>
          </div>
        </form>
      </vs-popup>
      <!-- Delete Confirmation Popup -->
      <vs-popup title="Delete Offer" :active.sync="deleteOfferPopup">
        <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this offer?</p>
        <div class="flex justify-end gap-2">
          <vs-button color="warning" @click="deleteOffer">Delete</vs-button>
          <vs-button color="primary" @click="deleteOfferPopup = false">Cancel</vs-button>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
// import { generateChart } from 'vue-chartjs';
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import Vue from "vue";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD-MM-YYYY");
  }
});

export default {
  name: "banner",
  components: {
    // uploader,
    Datepicker,
    // DatePicker,
    // VueTimepicker,
  },
  data: () => ({
    // time1: [],
    disabledDates: {
      to: new Date(Date.now() - 8640000),
    },
    disabledDatesEnd: {
      to: new Date(Date.now() - 8640000),
    },
    title: "Offer",
    colorx: "#0D2144",
    defaultalert: false,
    viewDetails: false,
    deleteOfferPopup: false,
    isNew: true,
    clone: false,
    search: {
      active: "",
      sort: "ASC",
      bundleId: "",
      status: "all",
      isToday: "false",
    },
    displayImage1: "",
    fileName1: "",
    banner: {
      title: "",
      bundleId: "",
      file: "",
      active: false,
      startDate: "",
      startTime: "",
      endTime: "",
      percentage: "",
      price: "",
      // contestId: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    apps: [],
    detail: {},
    showLoader: false,
  }),

  methods: {
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.banner = {
        title: "",
        bundleId: "",
        image: [],
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        percentage: "",
        price: "",
      };
      this.$data.displayImage1 = "";
      this.$data.fileName1 = "";
      this.$data.banner.startTime = "";
      this.$data.banner.endTime = "";
    },

    editingItem(i, data) {
      this.$data.banner = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage1 = i.file[0].url;
      this.$data.banner.startTime = i.startTime;
      this.$data.banner.endTime = i.endTime;
      this.$data.clone = data == "clone" ? true : false;
    },

    async resetData() {
      this.$data.search = {
        active: "",
        sort: "ASC",
        bundleId: "",
        status: "all",
        isToday: "false",
      };
      await this.fetchAll();
    },

    viewBannerDetails(i) {
      this.$data.detail.description = i.description;
      this.$data.detail.link = i.link;
      this.$data.viewDetails = true;
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.banner.file = file;
        this.displayImage1 = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage1 = "";
      this.banner.file = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    async uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      let isValid = false;
      if (!data || !data.target || !data.target.files || !data.target.files[0]) return;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        if (this.banner.file instanceof File) this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();

      formdata.append("file", data.target.files[0]);
      formdata.append("banner", this.$data.banner.title);
      this.$vs.loading();

      try {
        const response = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.error != null) {
          this.$vs.notify({
            title: "Uploading Error",
            text: response.data.error.message,
            color: "danger",
            position: "top-right",
          });
        } else {
          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });
          const data = response;
          this.displayImage1 = response.data.files[0].url;
          this.$refs.fileInput.value = null;
          this.$emit("input", data);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Error while uploading file",
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    dateSelected(e) {
      this.$data.disabledDatesEnd = {
        to: e,
      };
    },

    async btnAddBanner() {
      this.$vs.loading();

      try {
        let date = new Date(this.$data.banner.startDate);
        let eDate = new Date(this.$data.banner.endDate);

        if (this.$data.banner.startDate) {
          this.$data.banner.startDate = new Date(
            date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate() + " " + "00:00:00"
          ).toISOString();
        }

        if (this.$data.banner.endDate) {
          this.$data.banner.endDate = new Date(
            eDate.getFullYear() + "/" + (eDate.getMonth() + 1) + "/" + eDate.getDate() + " " + "23:59:59"
          ).toISOString();
        }

        if (this.banner.file instanceof File) await this.uploadImage({ target: { files: [this.$data.banner.file] } });

        let data = this.$data.banner;
        this.$data.banner.file = this.displayImage1;

        const missingFields = [
          { key: "title", message: "Offer title required" },
          { key: "description", message: "Offer description required" },
          { key: "bundleId", message: "Bundle Id required" },
          { key: "startDate", message: "Offer start date required" },
          { key: "endDate", message: "Offer end date required" },
          { key: "price", message: "discount price required" },
          { key: "percentage", message: "discount percentage required" },
          { key: "file", message: "Offer image required" },
        ];

        for (const field of missingFields) {
          if (!data[field.key]) {
            this.$vs.notify({
              title: field.message,
              color: "danger",
              position: "top-right",
            });
            return this.$vs.loading.close();
          }
        }

        data.file = [
          {
            _id: "",
            fileType: this.$data.banner.file ? this.$data.banner.file.split(".").pop() : "",
            url: this.$data.banner.file,
          },
        ];

        if (!this.$data.isNew && !this.$data.clone) {
          await this.update(data);
          return;
        } else if (this.$data.clone) {
          let data = {
            file: this.$data.banner.file,
            startDate: this.$data.banner.startDate,
            endDate: this.$data.banner.endDate,
            title: this.$data.banner.title,
            description: this.$data.banner.description,
            active: this.$data.banner.active,
            bundleId: this.$data.banner.bundleId,
            percentage: this.$data.banner.percentage,
            price: this.$data.banner.price,
          };

          await this.create(data);
        } else {
          await this.create(data);
        }
      } catch (error) {
        console.error("Error saving offer:", error);
        this.$vs.notify({
          title: "An error occurred while saving the offer.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async create(data) {
      let apiToCall = API.ADD_OFFER;
      this.$vs.loading();

      try {
        const r = await api.post(apiToCall, data);

        if (r.status === 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "An error occurred while saving the offer.",
          color: "danger",
          position: "top-right",
        });
        return;
      } finally {
        this.$vs.loading.close();
        await this.fetchAll();
      }
    },

    async update(data) {
      this.$vs.loading();
      try {
        const r = await api.put(API.UPDATE_OFFER + "?id=" + data._id, data);

        if (r.status === 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "An error occurred while updating the offer.",
          color: "danger",
          position: "top-right",
        });
        return;
      } finally {
        this.$vs.loading.close();
        await this.fetchAll();
      }
    },

    async fetchAll() {
      this.$vs.loading();

      try {
        const r = await api.get(
          `${API.GET_OFFER}?bundleId=${this.$data.search.bundleId}&active=${this.$data.search.active}&status=${this.$data.search.status}`
        );

        if (r.status === 200) this.$data.all = r.data;
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "An error occurred while fetching offers.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async deleteOffer() {
      this.$vs.loading();

      try {
        const r = await api.delete(API.DELETE_OFFER + "?id=" + this.$data.itemToDelete._id, {});
        if (r.status === 200)
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "An error occurred while deleting the offer.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$data.deleteOfferPopup = false;
        this.$vs.loading.close();
        await this.fetchAll();
      }
    },

    async fetchAllApps() {
      this.$vs.loading();

      try {
        const r = await api.get(`${API.GET_APP}?language=EN`);

        if (r.status === 200) this.$data.apps = r.data;
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "An error occurred while fetching apps.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    await Promise.all([this.fetchAll(), this.fetchAllApps()]);
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
